import { LitElement, html, css } from 'lit';
import { STATUS_STATES } from '../lib/palette.js';

/**
 * A threshold state (PRD 7.4) as it is always allowed to appear: colour plus an icon plus the
 * word. The four status colours are reserved — never a project type, never a series — and green
 * and red cannot be separated by hue under deuteranopia, so the icon and the label are not
 * decoration, they are the encoding.
 */
class StatusBadge extends LitElement {
  static properties = {
    state: { type: String },
    value: { type: String },
    compact: { type: Boolean },
  };

  static styles = css`
    :host {
      display: inline-block;
    }
    .badge {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      padding: 2px 9px 2px 7px;
      border-radius: var(--radius-pill);
      border: 1px solid currentColor;
      font-size: 12px;
      font-weight: 600;
      line-height: 18px;
      white-space: nowrap;
    }
    .icon {
      font-size: 10px;
      line-height: 1;
    }
    .value {
      font-variant-numeric: tabular-nums;
      opacity: 0.9;
    }
  `;

  render() {
    const state = STATUS_STATES.find((s) => s.key === this.state);
    if (!state) return html``;
    return html`
      <span
        class="badge"
        style=${`color: var(${state.var}); background: var(${state.tint});`}
        title=${state.label}
      >
        <span class="icon" aria-hidden="true">${state.icon}</span>
        ${this.compact ? '' : html`<span>${state.label}</span>`}
        ${this.value ? html`<span class="value">${this.value}</span>` : ''}
      </span>
    `;
  }
}

customElements.define('status-badge', StatusBadge);
